<section class="returns-detail-page">
  <button type="button" class="back-button" (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
    <span>Zurück zur Übersicht</span>
  </button>

  @if (isLoading()) {
  <header class="detail-header">
    <div class="skeleton skeleton-title"></div>
    <div class="skeleton skeleton-subline"></div>
  </header>

  <section class="kpi-grid">
    @for (card of skeletonKpiCards; track $index) {
    <div class="kpi-card">
      <div class="skeleton skeleton-kpi-value"></div>
      <div class="skeleton skeleton-kpi-label"></div>
    </div>
    }
  </section>
  } @else if (detail()) {
  <header class="detail-header">
    <div class="detail-header-main">
      <h1>Retoure F{{ detail()!.filialNummer }}</h1>
      <p>
        {{ detail()!.filialeName }}
        <span class="header-dot">·</span>
        F{{ detail()!.filialNummer }}
        <span class="header-dot">·</span>
        {{ detail()!.datum }}
      </p>
    </div>

    <span class="status-pill" [class]="getReturnStatusClass(detail()!.status)">
      {{ getReturnStatusLabel(detail()!.status) }}
    </span>
  </header>

  <section class="kpi-grid">
    <div class="kpi-card" [class.kpi-card-warning]="offenePositionen() > 0"
      [class.kpi-card-success]="offenePositionen() === 0">
      <span>Noch zu bearbeitende Artikel</span>
      <strong>{{ offenePositionen() }}</strong>
    </div>

    <div class="kpi-card kpi-card-disabled">
      <span>Gesamtwert</span>
      <strong>{{ formatCurrency(gesamtwert()) }} €</strong>
    </div>

    <div class="kpi-card kpi-card-disabled">
      <span>Anteil Tagesumsatz</span>
      <strong>{{ detail()!.anteilTagesumsatz === null ? '—' : formatPercent(detail()!.anteilTagesumsatz!) + '%' }}</strong>
    </div>
  </section>

  <section class="toolbar">
    <label class="search-field">
      <mat-icon>search</mat-icon>

      <input #searchInput type="text" placeholder="Suche nach Artikel…" [value]="searchTerm()"
        (input)="setSearchTerm(searchInput.value)" />

      @if (searchTerm()) {
      <button type="button" class="search-clear-button" aria-label="Suche zurücksetzen" (click)="setSearchTerm('')">
        <mat-icon>close</mat-icon>
      </button>
      }
    </label>

    <button type="button" class="add-article-button" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>Artikel hinzufügen</span>
    </button>

    <label class="compact-toggle">
      <input type="checkbox" [checked]="isCompact()" (change)="toggleCompact()" />

      <span>Kompaktmodus</span>
    </label>

    <button type="button" class="undo-button" [disabled]="!canUndo()" (click)="undo()">
      <mat-icon>undo</mat-icon>
      <span>Zurück</span>
    </button>
  </section>

  <section class="filter-bar">
    <div class="filter-group">
      @for (filter of statusFilters; track filter.value) {
      <button type="button" class="filter-chip" [class.filter-chip-active]="
              isStatusFilterActive(filter.value)
            " (click)="setStatusFilter(filter.value)">
        {{ filter.label }}
      </button>
      }
    </div>
  </section>

  @if (selectionCount() > 0) {
  <section class="bulk-bar">
    <span class="bulk-count">
      {{ selectionCount() }} ausgewählt
    </span>

    <button type="button" class="bulk-action bulk-action-capture" (click)="bulkMarkErfasst()">
      <span>Als erfasst markieren</span>
    </button>

    <button type="button" class="bulk-action bulk-action-clear" (click)="clearSelection()">
      <mat-icon>close</mat-icon>
      <span>Auswahl aufheben</span>
    </button>
  </section>
  }

  <section class="position-table" [class.position-table-compact]="isCompact()">
    <div class="table-header">
      <span class="col-checkbox">
        <span class="fake-checkbox" role="checkbox" [attr.tabindex]="
              selectablePositionen().length > 0
                ? 0
                : -1
            " aria-label="Alle offenen Positionen auswählen" [attr.aria-checked]="
              allFilteredSelected()
                ? 'true'
                : someFilteredSelected()
                  ? 'mixed'
                  : 'false'
            " [attr.aria-disabled]="
              selectablePositionen().length === 0
            " [class.checked]="allFilteredSelected()" [class.indeterminate]="
              someFilteredSelected() &&
              !allFilteredSelected()
            " [class.fake-checkbox-disabled]="
              selectablePositionen().length === 0
            " (click)="toggleSelectAllFiltered()" (keydown.enter)="toggleSelectAllFiltered()" (keydown.space)="
              $event.preventDefault();
              toggleSelectAllFiltered()
            "></span>
      </span>

      <button type="button" class="col-sort-button" [class.col-sort-button-active]="
            isSortedBy('artikel')
          " (click)="setSort('artikel')">
        <span>Artikel</span>
        <mat-icon>
          {{ getSortIcon('artikel') }}
        </mat-icon>
      </button>

      <button type="button" class="col-sort-button col-sort-button-numeric" [class.col-sort-button-active]="
            isSortedBy('menge')
          " (click)="setSort('menge')">
        <span>Menge</span>
        <mat-icon>
          {{ getSortIcon('menge') }}
        </mat-icon>
      </button>

      <span>Einheit</span>

      <span class="numeric header-hyphenate">
        Einzel&shy;preis
      </span>

      <button type="button" class="col-sort-button col-sort-button-numeric" [class.col-sort-button-active]="
            isSortedBy('gesamtwert')
          " (click)="setSort('gesamtwert')">
        <span class="header-hyphenate">
          Gesamt&shy;wert
        </span>

        <mat-icon>
          {{ getSortIcon('gesamtwert') }}
        </mat-icon>
      </button>

      <span>Status</span>
    </div>

    <div #tableBody class="table-body">
      @if (displayedPositionen().length === 0) {
      <div class="empty-state">
        Keine Positionen für den gewählten Filter.
      </div>
      } @else {
      @for (
      position of displayedPositionen();
      track position.rowId
      ) {
      <div class="table-row table-row-clickable" [attr.data-return-row-id]="position.rowId" [class]="getRowClass(position, $index)" [class.table-row-unerfasst]="
                istNeuOhneMenge(position)
              " (click)="openNumpad(position)">
        <span class="col-checkbox">
          <span class="fake-checkbox" role="checkbox" [attr.tabindex]="
                    isSelectable(position)
                      ? 0
                      : -1
                  " [attr.aria-label]="
                    'Position ' +
                    position.artikelName +
                    ' auswählen'
                  " [attr.aria-checked]="
                    isSelected(position)
                  " [attr.aria-disabled]="
                    !isSelectable(position)
                  " [class.checked]="
                    isSelected(position)
                  " [class.fake-checkbox-disabled]="
                    !isSelectable(position)
                  " (click)="
                    $event.stopPropagation();
                    toggleSelect(position)
                  " (keydown.enter)="
                    toggleSelect(position)
                  " (keydown.space)="
                    $event.preventDefault();
                    toggleSelect(position)
                  "></span>
        </span>

        <span class="artikel-cell">
          <span class="artikel-cell-name">
            {{ position.artikelName }}

            @if (istNeuOhneMenge(position)) {
            <span class="new-article-badge">
              Neu
            </span>
            }
          </span>

          <span class="artikel-cell-nummer">
            {{ position.artikelnummer }}
          </span>
        </span>

        <span class="numeric menge-cell" data-qty-cell="1">
          @if (isNumpadOpenFor(position)) {
          <input #mengeInput type="text" inputmode="numeric" pattern="[0-9]*" class="menge-input" [attr.aria-label]="
                      'Menge von ' +
                      position.artikelName +
                      ' bearbeiten'
                    " [value]="inputValue()" [placeholder]="placeholderValue()" (click)="
                      $event.stopPropagation();
                      mengeInput.select()
                    " (input)="
                      onInputChange(mengeInput)
                    " (keydown.enter)="
                      $event.preventDefault();
                      confirmAndNext()
                    " />
          } @else {
          <button type="button" class="menge-button" [attr.aria-label]="
                      'Menge von ' +
                      position.artikelName +
                      ' bearbeiten'
                    " title="Menge bearbeiten" (click)="
                      $event.stopPropagation();
                      openNumpad(position)
                    ">
            {{ getMengeText(position) }}
          </button>
          }
        </span>

        <span class="einheit-cell">
          <select #einheitSelect class="einheit-select" [attr.aria-label]="
                    'Einheit von ' +
                    position.artikelName +
                    ' wählen'
                  " (click)="$event.stopPropagation()" (change)="
                    changeEinheit(
                      position,
                      einheitSelect.value
                    )
                  ">
            @for (
            option of position.verfuegbareEinheiten;
            track option.einheit
            ) {
            <option [value]="option.einheit" [selected]="
                        option.einheit ===
                        position.einheit
                      " [disabled]="
                        istEinheitBelegt(
                          position,
                          option.einheit
                        )
                      ">
              {{ option.einheit }}
            </option>
            }
          </select>
        </span>

        <span class="numeric unit-dependent-value">
          {{ formatCurrency(position.einzelpreis) }} €
        </span>

        <span class="numeric total-cell unit-dependent-value">
          {{ formatCurrency(rowGesamtwert(position)) }} €
        </span>

        <span>
          <span class="position-status-pill" [class]="
                    getPositionStatusClass(
                      position.status
                    )
                  ">
            {{
            getPositionStatusLabel(
            position.status
            )
            }}
          </span>
        </span>
      </div>
      }
      }
    </div>
  </section>

  <footer class="detail-footer">
    <span class="footer-item-inline">
      Gefiltert:
      <strong>{{ gefiltertCount() }}</strong>
    </span>

    <span class="footer-item-inline">
      Gesamt:
      <strong>{{ gesamtCount() }}</strong>
    </span>

    <span class="footer-item-inline">
      Erfasst:
      <strong>{{ erfassteCount() }}</strong>
    </span>

    <div class="footer-actions">
      @if (offenePositionen() > 0) {
      <span class="footer-open">
        Noch
        <strong>{{ offenePositionen() }}</strong>
        Positionen offen
      </span>
      }

      <button type="button" class="close-return-button" [disabled]="!canClose()" (click)="openSummary()">
        Retoure abschließen
      </button>
    </div>
  </footer>

  @if (activePosition(); as active) {
  <div #numpadPanel class="numpad-panel" role="dialog" aria-modal="true" aria-label="Menge bearbeiten">
    <div class="numpad-inner">
      <div class="numpad-head">
        <div class="numpad-title">
          <span class="numpad-title-label">
            Menge:
          </span>

          <span class="numpad-title-artikel">
            {{ active.artikelName }}
          </span>

          @if (
          activeUnitOption();
          as unitOption
          ) {
          <span class="numpad-title-preis">
            ·
            {{
            formatCurrency(
            unitOption.einzelpreis
            )
            }}
            €
          </span>
          }
        </div>

        <button type="button" class="numpad-close" aria-label="Editor schließen" (click)="closeNumpad()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="numpad-units">
        @for (
        option of active.verfuegbareEinheiten;
        track option.einheit
        ) {
        <button type="button" class="numpad-unit-chip" [class.numpad-unit-chip-active]="
                  activeUnit() ===
                  option.einheit
                " [class.numpad-unit-chip-done]="
                  isUnitErfasst(
                    option.einheit
                  )
                " [attr.aria-pressed]="
                  activeUnit() ===
                  option.einheit
                " (click)="
                  selectUnit(
                    option.einheit
                  )
                ">
          <span class="numpad-unit-chip-name">
            {{ option.einheit }}
          </span>

          @if (
          isUnitErfasst(
          option.einheit
          )
          ) {
          <span class="numpad-unit-chip-menge">
            {{
            unitMenge(
            option.einheit
            )
            }}
          </span>
          }
        </button>
        }
      </div>

      <div class="numpad-display">
        <input #mengeInput type="text" inputmode="numeric" pattern="[0-9]*" class="numpad-input" aria-label="Menge"
          [value]="inputValue()" [attr.placeholder]="placeholderValue()" (input)="onInputChange(mengeInput)"
          (keydown.enter)="
                $event.preventDefault();
                confirmAndNext()
              " />

        <span class="numpad-unit">
          {{ activeUnit() }}
        </span>
      </div>

      @if (liveGesamtwert() !== null) {
      <div class="numpad-live-total">
        {{
        formatCurrency(
        liveGesamtwert()!
        )
        }}
        € Gesamtwert
      </div>
      }

      <div class="numpad-keys">
        @for (
        key of numpadKeys;
        track $index
        ) {
        @if (key === null) {
        <span class="numpad-key-spacer"></span>
        } @else {
        <button type="button" class="numpad-key" [class.numpad-key-backspace]="
                    key ===
                    numpadBackspace
                  " [attr.aria-label]="
                    key ===
                    numpadBackspace
                      ? 'Letzte Ziffer löschen'
                      : key
                  " (click)="pressKey(key)">
          {{ key }}
        </button>
        }
        }
      </div>

      <div class="numpad-steps">
        <button type="button" class="numpad-step" aria-label="Menge um 1 verringern" (click)="stepMenge(-1)">
          <mat-icon>remove</mat-icon>
          <span>1</span>
        </button>

        <button type="button" class="numpad-step" aria-label="Menge um 1 erhöhen" (click)="stepMenge(1)">
          <mat-icon>add</mat-icon>
          <span>1</span>
        </button>
      </div>

      <div class="numpad-actions">
        <button type="button" class="numpad-weitere" (click)="weitereEinheit()">
          <mat-icon>add</mat-icon>
          <span>Weitere Einheit</span>
        </button>

        <button type="button" class="numpad-confirm" (click)="confirmAndNext()">
          Fertig · Nächster
        </button>
      </div>
    </div>
  </div>
  }

  @if (isAddOpen()) {
  <div class="summary-overlay" (click)="closeAddDialog()">
    <div class="summary-dialog add-dialog" role="dialog" aria-modal="true" aria-labelledby="add-title"
      (click)="$event.stopPropagation()">
      <h2 id="add-title" class="summary-title">
        Artikel hinzufügen
      </h2>

      <button type="button" class="dialog-close" aria-label="Dialog schließen" (click)="closeAddDialog()">
        <mat-icon>close</mat-icon>
      </button>

      <label class="add-search">
        <mat-icon>search</mat-icon>

        <input #addSearch type="text" placeholder="Artikelname oder Artikelnummer suchen…"
          aria-label="Artikel im Katalog suchen" [value]="addQuery()" (input)="
                setAddQuery(
                  addSearch.value
                )
              " />
      </label>

      <div class="add-results">
        @if (
        katalogTreffer().length ===
        0
        ) {
        <p class="add-empty">
          Kein Artikel gefunden.
        </p>
        } @else {
        @for (
        artikel of katalogTreffer();
        track artikel.artikelnummer
        ) {
        <button type="button" class="add-result" (click)="
                    addKatalogArtikel(
                      artikel
                    )
                  ">
          <span class="add-result-text">
            <span class="add-result-name">
              {{ artikel.artikelName }}
            </span>

            <span class="add-result-number">
              {{ artikel.artikelnummer }}
            </span>
          </span>

          <span class="add-result-price numeric">
            {{
            formatCurrency(
            artikel.einzelpreis
            )
            }}
            €
          </span>
        </button>
        }
        }
      </div>

      <div class="add-actions">
        <button type="button" class="add-cancel" (click)="closeAddDialog()">
          Abbrechen
        </button>
      </div>
    </div>
  </div>
  }

  @if (isSummaryOpen()) {
  <div class="summary-overlay" (click)="closeSummary()">
    <div class="summary-dialog" role="dialog" aria-modal="true" aria-labelledby="summary-title"
      (click)="$event.stopPropagation()">
      <h2 id="summary-title" class="summary-title">
        Zusammenfassung Retoure
      </h2>

      <button type="button" class="dialog-close" aria-label="Dialog schließen" [disabled]="isClosing()"
        (click)="closeSummary()">
        <mat-icon>close</mat-icon>
      </button>

      <div class="summary-kpis">
        <div class="summary-kpi">
          <span class="summary-kpi-label">
            Erfasst
          </span>

          <span class="summary-kpi-value summary-kpi-captured">
            {{ erfassteCount() }}
          </span>
        </div>

        <div class="summary-kpi">
          <span class="summary-kpi-label">
            Offen
          </span>

          <span class="summary-kpi-value" [class.summary-kpi-open]="
                  offenePositionen() > 0
                ">
            {{ offenePositionen() }}
          </span>
        </div>

        <div class="summary-kpi">
          <span class="summary-kpi-label">
            Gesamtwert
          </span>

          <span class="summary-kpi-value">
            {{ formatCurrency(gesamtwert()) }} €
          </span>
        </div>
      </div>

      <div #summaryList class="summary-list" (scroll)="
              onSummaryScroll(
                summaryList
              )
            ">
        <table class="summary-table">
          <thead>
            <tr>
              <th>Artikel</th>
              <th class="numeric">
                Menge
              </th>
              <th class="numeric">
                Gesamtwert
              </th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            @for (
            position of summaryPositionen();
            track position.rowId
            ) {
            <tr>
              <td>
                <span class="summary-artikel-name">
                  {{ position.artikelName }}
                </span>

                <span class="summary-artikel-nummer">
                  {{ position.artikelnummer }}
                </span>
              </td>

              <td class="numeric">
                {{ getMengeText(position) }}
              </td>

              <td class="numeric">
                {{
                formatCurrency(
                position.gesamtwert
                )
                }}
                €
              </td>

              <td class="summary-position-status" [class]="
                        getPositionStatusClass(
                          position.status
                        )
                      ">
                {{
                getPositionStatusLabel(
                position.status
                )
                }}
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      @if (!summaryReviewed()) {
      <p class="summary-hint">
        Bitte scrolle durch die Liste der Positionen,
        um die Retoure final zu bestätigen.
      </p>
      }

      @if (closeError()) {
      <p class="summary-error" role="alert">
        Der Abschluss konnte nicht durchgeführt werden.
        Bitte versuche es erneut.
      </p>
      }

      <div class="summary-footer">
        <button type="button" class="summary-cancel" [disabled]="isClosing()" (click)="closeSummary()">
          Zurück
        </button>

        <button type="button" class="summary-confirm" [disabled]="
                !summaryReviewed() ||
                isClosing()
              " (click)="confirmClose()">
          Retoure bestätigen
        </button>
      </div>
    </div>
  </div>
  }
  } @else {
  <div class="empty-state detail-empty">
    Retoure konnte nicht geladen werden.
  </div>
  }
</section>